<template>
    <div>
        <a
            href="#"
            class="list-order"
            :class="orderClass"
            @click.prevent="onClick"
        >
            <slot />
        </a>
    </div>
</template>
<script>
export default {
    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        by: {
            required: true,
            type: String,
        },

        value: {
            type: Object,
            default: () => ({
                by: null,
                direction: null,
            }),
        },
    },

    computed: {
        /**
         * Computes order classes.
         *
         * @returns {object} Order classes.
         */
        orderClass() {
            return {
                active: this.value.by === this.by,
                'sort-down': this.value.by === this.by && 'desc' === this.value.direction,
                'sort-up': this.value.by === this.by && 'asc' === this.value.direction,
            };
        },
    },

    methods: {
        /**
         * Handles click event.
         */
        onClick() {
            const order = this.value;

            if (order.by !== this.by) {
                order.direction = null;
            }

            order.by = this.by;

            if (! order.direction || 'desc' === order.direction) {
                order.direction = 'asc';
            } else {
                order.direction = 'desc';
            }

            this.$emit('change', order);
        },
    },
};
</script>
